import React from "react";
import ContentGutter from "../../ContentGutter";
import SiteWrapper from "../../SiteWrapper";
import t from "../../../utils/translate";
import responsiveImages from "../../../utils/responsiveImages";

import styles from "./styles.module.scss";
import useAppContext from "../../AppContext";

export default function ResultsEliNone() {
  const { newQuiz } = useAppContext();
  const images = [
    {
      altTag: "",
      url: t("NOT_ELIGIBLE_MOBILE_IMAGE")
    },
    {
      altTag: "",
      url: t("NOT_ELIGIBLE_DESKTOP_IMAGE")
    }
  ];

  return (
    <div className={styles.wrapper}>
      <ContentGutter>
        <SiteWrapper size="small">
          <div className={styles.header}>
            {newQuiz.isUni
              ? t("NOT_ELIGIBLE_HEADER_UNI")
              : t("NOT_ELIGIBLE_HEADER")}
          </div>
          <div className={styles.image}>{responsiveImages(images)}</div>
          <p className={styles.body}>{t("NOT_ELIGIBLE_BODY2")}</p>
          <section className={styles.centered}>
            <a className={styles.cta} href={t("NOT_ELIGIBLE_NONE_CTA1_LINK")}>
              {t("NOT_ELIGIBLE_NONE_CTA1_TEXT")}
            </a>
          </section>
        </SiteWrapper>
      </ContentGutter>
    </div>
  );
}
